export default "__VITE_PUBLIC_ASSET__37f78472__"